<template>
  <base-section id="theme-features" space="10">
    <base-section-heading :title="$t('home.text.register')" icon="mdi-animation-outline">
      {{$t('home.html.register')}}
    </base-section-heading>

    <v-container>
      <v-row class="ml-2 mr-2">
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
          <v-chip v-if="feature.to"
            class="mr-2 mt-2"
            @click="navigateTo(feature.to)"
            color="primary"
          >
            <span style="color:white;">{{$t('home.go_to')}}</span>
            <v-icon color="white" right>mdi-arrow-right-bold</v-icon>
          </v-chip>
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>

export default {
  name: 'OthersFeatures',

  methods: {
    navigateTo (path) {
      this.$router.push(path)
    }
  },

  computed: {
    features () {
      return [
        {
          title: this.$t('keywords.db'),
          icon: 'mdi-database',
          html: this.$t('home.html.db'),
          to: '/cadastro-dbp'
        },
        {
          title: this.$t('keywords.credentials'),
          icon: 'mdi-card-account-details-outline',
          html: this.$t('home.html.credentials'),
          to: '/credentials'
        },
        {
          title: this.$t('keywords.from_to'),
          icon: 'mdi-swap-horizontal',
          html: this.$t('home.html.from_to'),
          to: '/from-to'
        },
        {
          title: this.$t('keywords.params'),
          icon: 'mdi-download-multiple',
          html: this.$t('home.html.params'),
          to: '/parameter'
        },
        {
          title: this.$t('keywords.server.email'),
          icon: 'mdi-email-send',
          html: this.$t('home.html.mail_server'),
          to: '/emailserver'
        }
      ]
    }
  }

}
</script>
